import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import { DEFAULT_MOBILE_PROPS, DEFAULT_PAGINATION_PROPS, DEFAULT_TABLET_PROPS } from './PaginatedGrid.constants';
export function getGridProps() {
  var desktopProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mobileProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tabletProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    isMobile = _ref.isMobile,
    isTablet = _ref.isTablet;
  var mobilePropsWithDefaults = _objectSpread(_objectSpread({}, DEFAULT_MOBILE_PROPS), mobileProps);
  var tabletPropsWithDefaults = _objectSpread(_objectSpread({}, DEFAULT_TABLET_PROPS), tabletProps);
  var desktopColumns = desktopProps.columns;
  var mobileColumns = mobilePropsWithDefaults.columns,
    mobileStackable = mobilePropsWithDefaults.stackable;
  var tabletColumns = tabletPropsWithDefaults.columns,
    tabletDoubling = tabletPropsWithDefaults.doubling;
  var finalDesktopProps = {
    columns: desktopColumns
  };
  var finalMobileProps = {
    columns: mobileColumns || desktopColumns,
    stackable: mobileStackable
  };
  var finalTabletProps = {
    columns: tabletColumns || desktopColumns,
    doubling: tabletDoubling
  };
  if (isMobile) {
    return finalMobileProps;
  }
  if (isTablet) {
    return finalTabletProps;
  }
  return finalDesktopProps;
}
export function getPaginationProps() {
  var paginationProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, DEFAULT_PAGINATION_PROPS), paginationProps);
}
export function getPageSize(items) {
  var desktopPageOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mobilePageOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var tabletPageOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _ref2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
    isMobile = _ref2.isMobile,
    isTablet = _ref2.isTablet;
  var columns = desktopPageOptions.columns,
    rows = desktopPageOptions.rows;
  var mobilePropsWithDefaults = _objectSpread(_objectSpread({}, DEFAULT_MOBILE_PROPS), mobilePageOptions);
  var mobileColumns = mobilePropsWithDefaults.columns,
    mobileRows = mobilePropsWithDefaults.rows,
    mobileDisplayAll = mobilePropsWithDefaults.displayAll;
  var tabletPropsWithDefaults = _objectSpread(_objectSpread({}, DEFAULT_TABLET_PROPS), tabletPageOptions);
  var tabletColumns = tabletPropsWithDefaults.columns,
    tabletRows = tabletPropsWithDefaults.rows,
    tabletDisplayAll = tabletPropsWithDefaults.displayAll;
  var desktopPageSize = columns * rows;
  var tabletPageSize = tabletColumns * tabletRows;
  var mobilePageSize = mobileColumns * mobileRows;
  var itemsLength = items.length;
  if (isMobile) {
    if (mobileDisplayAll) {
      return itemsLength;
    }
    if (!_isNil(mobilePageSize) && _isNumber(mobilePageSize) && mobilePageSize > 0) {
      return mobilePageSize;
    }
  }
  if (isTablet) {
    if (tabletDisplayAll) {
      return itemsLength;
    }
    if (!_isNil(tabletPageSize) && _isNumber(tabletPageSize) && tabletPageSize > 0) {
      return tabletPageSize;
    }
  }
  return desktopPageSize;
}
export function canSafelyServerRender(items) {
  var desktopPageOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mobilePageOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var tabletPageOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var desktopPageSize = getPageSize(items, desktopPageOptions, {}, {}, {
    isDesktop: true
  });
  var tabletPageSize = getPageSize(items, desktopPageOptions, {}, tabletPageOptions, {
    isTablet: true
  });
  var mobilePageSize = getPageSize(items, desktopPageOptions, mobilePageOptions, {}, {
    isMobile: true
  });
  return mobilePageSize === desktopPageSize && tabletPageSize === mobilePageSize;
}